/**
 * tenantUsersApi.ts - wrapper pour /api/tenant-users/*
 * Gestion des utilisateurs secondaires du tenant (Business+ uniquement cote backend).
 */
import { apiFetch } from './apiClient';

export type UserRole = 'admin' | 'auditor' | 'viewer';

export interface TenantUser {
  id:          string;
  email:       string;
  name:        string;
  role:        UserRole;
  status:      'pending' | 'active' | 'disabled';
  createdAt:   string;
  invitedAt?:  string | null;
  acceptedAt?: string | null;
  lastLoginAt: string | null;
  hasPassword: boolean;
  isCurrent:   boolean;
}

export interface TenantUsersList {
  items: TenantUser[];
  total: number;
  plan:  string;
}

export interface CreateUserPayload {
  email:    string;
  name:     string;
  role:     UserRole;
  /** Password obligatoire en MVP : utilise pour le login apres acceptation de l invitation. */
  password: string;
  /** Locale du mail d invitation (fr-BE/nl-BE/de-BE/en). */
  preferredLanguage?: string;
}

export interface CreateUserResponse extends TenantUser {
  mailSent?:    boolean;
  mailError?:   string | null;
  message?:     string;
}

export const tenantUsersApi = {
  list:   ()                          => apiFetch<TenantUsersList>('/tenant-users'),
  create: (p: CreateUserPayload)      => apiFetch<CreateUserResponse>('/tenant-users', {
    method: 'POST',
    body:   JSON.stringify(p),
  }),
  remove: (userId: string)            => apiFetch<{ deleted: boolean; userId: string }>(`/tenant-users/${userId}`, {
    method: 'DELETE',
  }),
};
